
(function(template){
    define('vue!app/views/vue/components/cartComponent/cartBody/userComponent',[
        'Vue','vuex','vue!./serviceComponent', 'underscore'
    ], function(Vue,vuex,serviceComponent,_) {
        return {
            template:template,
            props: ['userId','userIndex','showUserName','showCart'],
            data: function() {
                return {
                    showServices : true
                }
            },
            components: {
                'service-component':serviceComponent,
            },
            computed: _.extend(vuex.mapState(['users','activeUser','activeStep','usersWithIds','loggedInUser', 'users', 'OTBactive']),
            {
                hideDeleteButton: function() {
                    return _.values(this.users[this.userId]).some(function(service){
                        return !!service.SpaFolioItemId;
                    });
                }
            }),
            methods:{
                toggleShowServices: function() {
                    this.showServices = !this.showServices;
                },
                handleKeyDown: function(e){
                    var vm = this;
                    this.a11yKeyDown(e, {
                        enter: function() {
                            vm.toggleShowServices();
                        },
                        tab: function() {
                            if(!vm.hideDeleteButton) {
                            }
                        }
                    })
                },
                handleDelete: function(){
                    this.$store.commit('removeGuestMember',{userId:this.userId});
                }
            },
            mounted: function () {
               
                if(Object.keys(this.users)[0] != this.userId && this.OTBactive) this.$store.commit('removeGuestMember',{userId:this.userId});
            }
        }        
    });
})('<div class="cart-user" :id="userId" v-if="Object.keys(users[userId]).length>0 || activeStep==0"> <div class="cart-user-header" tabindex="0" @keydown="handleKeyDown" v-show="showUserName" :class="{\'curved-top\': Object.keys(users[userId]).length>0, \'border-bottom\':showServices }"> {{usersWithIds[userId]}} <span class="cart-user-controls"> <i v-if="activeStep==0 && loggedInUser && !hideDeleteButton" @click="handleDelete" tabindex="0" class="far fa-trash-alt"></i> <i @click="toggleShowServices" tabindex="0" class="fas" :class="showServices ? \'fa-chevron-down\' : \'fa-chevron-left\'"></i> </span> </div> <div class="cart-user-body" v-show="showServices" > <service-component :userIndex="userIndex" :service_index="index" :userId="userId" :service_key="key" :service="service" v-for="(service,key,index) in users[userId]" :key="index"></service-component> </div> </div>');
